import { SpacerStyles } from "./spacer-styles";

export const Spacer = () => {
    const classes = SpacerStyles();
    
    return (<div className={classes.root}/>)
}
